import { Component, Input, Optional } from "@angular/core";
import { Router } from "@angular/router";
import { AppOnlineStateService } from "@main/pwa/app-online-state.service";
import { UserService } from "@main/users";
import { AutoSaveDirective } from "@mipro/directives";
import { FormButtonsConfig } from "./form-buttons-config";

@Component({
    selector: "form-buttons",
    templateUrl: "./form-buttons.component.html",
    styles: [
        `
            :host ::ng-deep .p-button:not(.fb-save) {
                margin-right: 0.25rem;
            }
        `
    ]
})
export class FormButtonsComponent {
    private _config: FormButtonsConfig = {
        saveLabel: "Save",
        cancelLabel: "Cancel",
        overrideAutoSave: true,
        justifyContent: "start"
    };

    @Input() get config() {
        return this._config;
    }
    set config(c: FormButtonsConfig) {
        Object.assign(this._config, c);
    }
    @Input() disabled: boolean;
    @Input() cancelDisabled: boolean;
    @Input() hideCancelButton: boolean;
    @Input() saving: boolean;
    @Input() layout: "standard" | "centered" | "spread" = "standard";
    @Input() allowOffline: any;

    constructor(
        private router: Router,
        private userService: UserService,
        @Optional() private autoSaveDirective: AutoSaveDirective,
        private onlineService: AppOnlineStateService
    ) {}

    get disabledOffline() {
        return !this.onlineService.isAppOnline && this.allowOffline == null;
    }

    get showCancelButton() {
        return !!(this._config.cancelUrl || this._config.cancelFunc) && !this.hideCancelButton;
    }

    get saveEnabled() {
        return (
            this._config.overrideAutoSave ||
            this.autoSaveDirective == null ||
            this.autoSaveDirective.hasIgnoredFieldModified ||
            !this.userService.currentUser?.autoSaveForms
        );
    }

    get saveLabel() {
        return this._config.saveLabel;
    }

    get cancelLabel() {
        return this._config.cancelLabel;
    }

    save(ev: MouseEvent) {
        if (this._config.saveFunc) {
            ev.stopPropagation();
            this._config.saveFunc();
        }
    }

    cancel() {
        if (this._config.cancelFunc) {
            this._config.cancelFunc();
        } else if (this._config.cancelUrl) {
            this.router.navigateByUrl(this._config.cancelUrl);
        }
    }
}
